/* deal-availability.js
   Works with the "Deal of the Day" section BUTTON variant UI
   - Hides option2 values (ex: Color) that don't exist for selected option1 (ex: Size)
   - Updates hidden variant id, price, compare-at price
*/

(function () {
  function decodeHtml(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  function parseVariants(widget) {
    const raw = widget.getAttribute("data-variants-json");
    if (!raw) return null;
    try {
      return JSON.parse(decodeHtml(raw));
    } catch (e) {
      console.warn("[Deal] variants JSON parse error", e);
      return null;
    }
  }

  function moneyFormatFromDom(widget, cents) {
    // simplest: read any existing price text and replace number formatting is hard.
    // We'll just use Shopify.formatMoney if available, else fallback.
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      // theme usually exposes Shopify.money_format
      return Shopify.formatMoney(cents, (Shopify.money_format || "{{amount}}"));
    }
    // fallback: EUR style
    return (cents / 100).toFixed(2) + " €";
  }

  function getGroups(widget) {
    return Array.from(widget.querySelectorAll(".deal-variant-group"));
  }

  function getButtons(group) {
    return Array.from(group.querySelectorAll(".deal-variant-btn"));
  }

  function setSelected(group, value) {
    getButtons(group).forEach((btn) => {
      const is = btn.getAttribute("data-option-value") === value;
      btn.classList.toggle("is-selected", is);
    });
  }

  function getSelectedValue(group) {
    const btn = group.querySelector(".deal-variant-btn.is-selected");
    return btn ? btn.getAttribute("data-option-value") : null;
  }

  function showHideButtons(group, allowedSet) {
    getButtons(group).forEach((btn) => {
      const val = btn.getAttribute("data-option-value");
      const ok = allowedSet.has(val);

      // hide values that do not exist for current selection
      btn.style.display = ok ? "" : "none";

      // if hidden, remove selection
      if (!ok) btn.classList.remove("is-selected");
    });
  }

  function findMatchingVariant(variants, selected) {
    // selected = [opt1, opt2, opt3]
    const matches = variants.filter((v) => {
      if (selected[0] && v.option1 !== selected[0]) return false;
      if (selected[1] && v.option2 !== selected[1]) return false;
      if (selected[2] && v.option3 !== selected[2]) return false;
      return true;
    });

    // prefer available variant first
    return matches.find((v) => v.available) || matches[0] || null;
  }

  function refresh(widget) {
    const variants = parseVariants(widget);
    if (!variants || !variants.length) return;

    const form = widget.querySelector('form[data-deal-form]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    const priceEl = widget.querySelector(".deal-of-the-day-price");
    const compareEl = widget.querySelector(".deal-of-the-day-compare");

    const groups = getGroups(widget);
    const selected = [null, null, null];

    // read current selections from UI
    groups.forEach((g) => {
      const pos = parseInt(g.getAttribute("data-option-position"), 10);
      if (!pos || pos < 1 || pos > 3) return;
      selected[pos - 1] = getSelectedValue(g);
    });

    // If option1 not selected, select first visible button in option1
    const g1 = groups.find(g => g.getAttribute("data-option-position") === "1");
    if (g1 && !selected[0]) {
      const firstBtn = getButtons(g1).find(b => b.style.display !== "none");
      if (firstBtn) {
        firstBtn.classList.add("is-selected");
        selected[0] = firstBtn.getAttribute("data-option-value");
      }
    }

    // --- Hide/show option2 based on option1
    const g2 = groups.find(g => g.getAttribute("data-option-position") === "2");
    if (g2 && selected[0]) {
      const allowed2 = new Set(
        variants
          .filter(v => v.option1 === selected[0])
          .map(v => v.option2)
          .filter(Boolean)
      );

      showHideButtons(g2, allowed2);

      // if option2 missing after hide, pick first visible
      selected[1] = getSelectedValue(g2);
      if (!selected[1]) {
        const firstVisible2 = getButtons(g2).find(b => b.style.display !== "none");
        if (firstVisible2) {
          firstVisible2.classList.add("is-selected");
          selected[1] = firstVisible2.getAttribute("data-option-value");
        }
      }
    }

    // --- (Optional) Hide/show option3 based on option1+option2
    const g3 = groups.find(g => g.getAttribute("data-option-position") === "3");
    if (g3 && selected[0] && selected[1]) {
      const allowed3 = new Set(
        variants
          .filter(v => v.option1 === selected[0] && v.option2 === selected[1])
          .map(v => v.option3)
          .filter(Boolean)
      );
      showHideButtons(g3, allowed3);

      selected[2] = getSelectedValue(g3);
      if (!selected[2]) {
        const firstVisible3 = getButtons(g3).find(b => b.style.display !== "none");
        if (firstVisible3) {
          firstVisible3.classList.add("is-selected");
          selected[2] = firstVisible3.getAttribute("data-option-value");
        }
      }
    }

    // Find variant & update hidden id + prices
    const variant = findMatchingVariant(variants, selected);
    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    if (priceEl) priceEl.textContent = moneyFormatFromDom(widget, variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.style.display = "";
        compareEl.textContent = moneyFormatFromDom(widget, variant.compare_at_price);
      } else {
        compareEl.style.display = "none";
      }
    }
  }

  function bind(widget) {
    widget.addEventListener("click", function (e) {
      const btn = e.target.closest(".deal-variant-btn");
      if (!btn) return;

      e.preventDefault();

      const group = btn.closest(".deal-variant-group");
      if (!group) return;

      // select clicked value in its group
      getButtons(group).forEach(b => b.classList.remove("is-selected"));
      btn.classList.add("is-selected");

      refresh(widget);
    });

    // initial
    refresh(widget);
  }

  function init() {
    // run only on homepage
    if (!document.body.classList.contains("index") && !document.body.classList.contains("template-index")) return;

    document.querySelectorAll(".deal-of-the-day-info[data-deal-variant-widget]").forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
})();